import { render, staticRenderFns } from "./DocManage.vue?vue&type=template&id=fd898918&scoped=true"
import script from "./DocManage.vue?vue&type=script&lang=js"
export * from "./DocManage.vue?vue&type=script&lang=js"
import style0 from "./DocManage.vue?vue&type=style&index=0&id=fd898918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd898918",
  null
  
)

export default component.exports